<template>
  <el-dialog
    width="390px"
    class="form-modal"
    v-loading="pauseProcessing"
    :visible.sync="visible"
    :before-close="close"
    :close-on-click-modal="false"
  >
    <h2 class="form-section-header text-center">AGENT PAUSE REASON</h2>
    <el-form>
      <dads-select v-model="reason" placeholder="Select a reason">
        <el-option
          v-for="item in reasonOptions"
          :key="item"
          :label="item"
          :value="item"
        />
        <template slot="prefix">Reason</template>
      </dads-select>

      <el-input
        v-if="reason === 'Other'"
        v-model="otherReason"
        placeholder="Specify other reason"
      >
        <template slot="prefix">Other Reason</template>
      </el-input>

      <div class="flex justify-center mt-20">
        <el-button type="primary" @click="submit">Submit</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import DadsSelect from "@/components/select";

export default {
  name: "QueuePauseModal",

  components: { DadsSelect },

  props: {
    visible: {
      required: true,
    },
    pauseProcessing: {
      required: true,
    },
  },

  data() {
    return {
      reason: "",
      otherReason: "",
      reasonOptions: [
        "Account Review",
        "Break",
        "Lunch",
        "Meeting",
        "Personal",
        "Other",
      ],
    };
  },
  methods: {
    close() {
      this.clearFields();
      this.$emit("closeOperation");
    },

    submit() {
      if (!this.reason) {
        return this.$notify({
          title: "Invalid Data",
          message: "Please select a reason",
          type: "error",
        });
      }

      if (this.reason === "Other" && !this.otherReason) {
        return this.$notify({
          title: "Invalid Data",
          message: "Please specify other reason",
          type: "error",
        });
      }

      const reason = this.reason === "Other" ? this.otherReason : this.reason;
      this.$emit("pauseOperation", reason);
    },

    clearFields() {
      this.reason = "";
      this.otherReason = "";
    },
  },
};
</script>
